/* unplugin-vue-components disabled */import { render } from "./templateTicket.vue?vue&type=template&id=07c23c9a"
import script from "./templateTicket.vue?vue&type=script&lang=js"
export * from "./templateTicket.vue?vue&type=script&lang=js"

import exportComponent from "/home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__